import { useTranslation } from 'react-i18next';
import type { CartAmazonDeal } from 'src/types';
import { shownAmazonBadge } from '../deals/amazonItemFilters';
import { DealExpiryPill } from '../deals/DealExpiryPill';

type Props = {
  deal: CartAmazonDeal;
};

const chipClass = 'rounded px-1.5 py-0.5 text-xs font-semibold';
// Cart rows are white, so these take the item card's amber where the card uses white.
const amberChip = `${chipClass} bg-[#FBE9BA] text-[#302404]`;

export const AmazonDealBadges = ({ deal }: Props) => {
  const { t } = useTranslation();
  const badge = shownAmazonBadge(deal.badge);
  const percentOff = (deal.savingsPercent ?? 0) > 0 ? deal.savingsPercent : undefined;
  if (!badge && deal.state !== 'prime' && percentOff === undefined && !deal.endTime) return null;

  return (
    <div className='flex animate-fadeIn flex-wrap items-center gap-2 pt-2'>
      {badge && (
        <span translate='no' className={amberChip}>
          {badge}
        </span>
      )}
      {deal.state === 'prime' && <span className={amberChip}>{t('deals.amazon.prime_only')}</span>}
      {percentOff !== undefined && (
        <span
          className={
            deal.state === 'savings'
              ? `${chipClass} border border-gray-300 text-primary-dark`
              : `${chipClass} bg-primary text-offWhite`
          }
        >
          {t('deals.amazon.percent_off', { pct: percentOff })}
        </span>
      )}
      <DealExpiryPill expiresAt={deal.endTime} />
    </div>
  );
};
